import { ACTIONS } from '../Constants';
import { VerbFetch } from '../VerbFetch';

export const getSuppressionData = (params) => (dispatch) => {
    const { email, pathsContext } = params;
    const emailToPass = email.replace('+', '%2B');
    const url = `${pathsContext.serverUrl}/email/suppressiondata?email=${emailToPass}`;
    return VerbFetch(url).then((body) => {
        dispatch({
            type: ACTIONS.GET_SUPPRESSION_DATA,
            payload: {
                suppressionData: body
            }
        });
    });
};

export const putSuppressionData = (params) => {
    const { suppressionId, suppressionData, pathsContext } = params;

    const fetchOptions = {
        method: 'PUT',
        body: suppressionData
    };

    return (dispatch) => {
        const url = `${pathsContext.serverUrl}/email/suppressiondata/${suppressionId}`;
        return VerbFetch(url, fetchOptions).then((body) => {
            dispatch({
                type: ACTIONS.PUT_SUPPRESSION_DATA,
                payload: {
                    suppressionData: body
                }
            });
        });
    };
};
